
/**
 * Classe responsável mapear os tipos de atributos da camada
*/

export default class TipoAtributoCamada {
	
	static get BOOLEANO () {
		return 'BOOLEANO';
	}

	static get DATA () {
		return 'DATA';
	}

	static get DECIMAL () {
		return 'DECIMAL';
	}

	static get INTEIRO () {
		return 'INTEIRO';
	}

	static get TEXTO () {
		return 'TEXTO';
	}

	static get OUTROS () {
		return 'OUTROS';
	}
}



// WEBPACK FOOTER //
// ./src/models/tipoAtributoCamada.js